// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "-legacy." + {"120":"beea553f","856":"d25e7139","943":"e349552e","966":"3487e991"}[chunkId] + ".js";
};